export const colorsConfig = {
  primary: "#2A1579",
  secondary: "#5C1579",
  black: "#000",
  white: "#fff",
};
